import { TokenAutenticazioneVO } from "@vo/token-autenticazione-VO";
import { TokenAutenticazioneDTO } from "@dto/token-autenticazioneDTO";
import { Injectable } from "@angular/core";

import { MapperInterface } from "@mapper/mapper-inteface";

@Injectable({
    providedIn: "root"
  })
export class MapperTokenAutenticazione
    implements MapperInterface<TokenAutenticazioneDTO, TokenAutenticazioneVO> {
    public convertVoToDto(vo: TokenAutenticazioneVO): TokenAutenticazioneDTO {
        const dto = new TokenAutenticazioneDTO();
        dto.dataCreazione = vo.dataCreazione;
        dto.refreshToken = vo.refreshToken;
        dto.secondiValidita = vo.secondiValidita;
        dto.tipoToken = vo.tipoToken;
        dto.token = vo.token;
        return dto;
    }
    public convertDtoToVo(dto: TokenAutenticazioneDTO): TokenAutenticazioneVO {
        const vo = new TokenAutenticazioneVO();
        vo.dataCreazione = dto.dataCreazione;
        vo.refreshToken = dto.refreshToken;
        vo.secondiValidita = dto.secondiValidita;
        vo.tipoToken = dto.tipoToken;
        vo.token = dto.token;
        return vo;
    }

    public convertListVoToDto(
        e: TokenAutenticazioneVO[]
    ): TokenAutenticazioneDTO[] {
        throw new Error("Method not implemented.");
    }
    public convertListDtoToVo(
        t: TokenAutenticazioneDTO[]
    ): TokenAutenticazioneVO[] {
        throw new Error("Method not implemented.");
    }
}
